export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "order-form.worker.098439aba1a9b7bd.worker.js");
}
